<template>
  <split-modal class="share-modal" v-bind="$attrs" size="xl" :title="$t('cmrad.share')">
    <share-case-form ref="shareCaseForm" :shared-case="sharedCase" />
    <template #modal-footer>
      <cancel-btn :disabled="busy" @click="onCancel" />
      <submit-btn :disabled="busy" @click="onSubmit" />
    </template>
  </split-modal>
</template>

<script>
  import SplitModal from '@/Atoms/SplitModal';
  import { CaseResource } from '@/api-resources';
  import ShareCaseForm from './ShareCaseForm';

  export default {
    name: 'ShareCaseModal',

    components: {
      SplitModal,
      ShareCaseForm,
    },

    props: {
      sharedCase: CaseResource,
      sharesCount: Number,
    },

    data() {
      return {
        busy: false,
      };
    },

    methods: {
      onSubmit() {
        this.busy = true;

        this.$refs.shareCaseForm
          .submit()
          .then(() => {
            this.$bvModal.hide(this.$attrs.id);
            this.$emit('update:sharesCount', this.sharesCount + 1);
          })
          .catch(() => {})
          .finally(() => {
            this.busy = false;
          });
      },

      onCancel() {
        this.$bvModal.hide(this.$attrs.id);
      },
    },
  };
</script>
